import React from 'react';
import DuperbrowseStreamContextProvider from './DuperbrowseStreamContextProvider';
const DeviationDuperbrowseContext = ({ children , deviations , streamId , parent  })=>{
    return /*#__PURE__*/ React.createElement(DuperbrowseStreamContextProvider, {
        stream: {
            items: deviations,
            streamId,
            parent
        }
    }, children);
};
DeviationDuperbrowseContext.displayName = 'DeviationDuperbrowseContext';
export default DeviationDuperbrowseContext;
